import { render, staticRenderFns } from "./CampaignStatSectionHeading.vue?vue&type=template&id=a3bf0258&"
import script from "./CampaignStatSectionHeading.vue?vue&type=script&lang=js&"
export * from "./CampaignStatSectionHeading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports